import styled, { css } from "styled-components";

export const LightBg = styled.div`
    padding: 75px 125px;
    background: #FFFFFF;
`;

export const ParentCard = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    gap: 5rem;
`;

export const HorizontalBar = styled.div`
    grid-column: 1 / span 2;
    z-index: 1;

    background: #ffffff;

    @media screen and (max-width: 1180px) {
      // margin: 0px 0px 0px 0px;
      grid-column: 1 / span 1;
    }
  }
`;

export const Pagination = styled.section`
    display: flex;
    justify-content: center;
`;

export const PaginationButton = styled.p`
    position: relative;
    width: 30px;
    padding: 1px;
    font-size: 16px;
    font-weight: 500;
    height: 32.5px;
    margin: 0 4px;
    text-align: center;
    color: #6554C0;
    user-select: none;
    border: 2px solid #DADADA;
    border-radius: 5px;

    &:hover {
        cursor: pointer;
        background: #DADADA;
        color: #6554C0;
        transition: 0.3s ease-out;
    }
    @media screen and (max-width: 500px) {
        width: 30px;
        height: 30px;
        font-size: 16px;
        margin: 0 2px;
    }
    ${(props) =>
        props.active &&
        css`
          background: #6554C0;
          color: #DADADA;
        //   border-radius: 10%;
        `}
    
      ${(props) =>
        props.unshow &&
        css`
          display: none;
        `}
    
`;